import { Box, Button, Grid, Typography } from '@mui/material';
import { ChevronDown, ChevronUp } from '@procore/core-icons';
import React, { useState } from 'react';
import { License } from '../../types/business';
import CollapsibleContent from '../Layout/CollapsibleContent';
import BusinessLicense from './BusinessLicense';
import { useStyles } from './BusinessProfileLicenses.styles';

interface Props {
  businessName: string;
  licenses: License[];
}
const BusinessProfileLicenses = ({ businessName, licenses }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const title = `${
    businessName.endsWith('s') ? `${businessName}'` : `${businessName}'s`
  } Licenses`;
  const intialDisplayLength = 8;
  const displayCollapsibleSection = licenses.length > intialDisplayLength;
  return (
    <Box data-test-id="business-profile-licenses" pt={3} pb={3}>
      <Typography className={classes.header} variant="h2">
        {title}
      </Typography>
      <Grid
        container
        columnSpacing={7}
        data-test-id="intial-licenses-container"
      >
        {licenses.slice(0, intialDisplayLength).map((license: License) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            marginTop={2}
            key={license.licenseNumber}
          >
            <BusinessLicense buinessLicense={license} />
          </Grid>
        ))}
      </Grid>
      {displayCollapsibleSection && (
        <>
          <CollapsibleContent isExpanded={open}>
            <Grid
              container
              columnSpacing={7}
              data-test-id="additional-licenses-container"
            >
              {licenses.slice(intialDisplayLength).map((license: License) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  marginTop={2}
                  key={license.licenseNumber}
                >
                  <BusinessLicense buinessLicense={license} />
                </Grid>
              ))}
            </Grid>
          </CollapsibleContent>
          <Box className={classes.CollapsibleContentButtonContainer}>
            <Button
              disableRipple
              variant="text"
              endIcon={open ? <ChevronUp /> : <ChevronDown />}
              className={classes.viewMoreButton}
              onClick={() => setOpen(!open)}
              data-test-id="Collapsible-button-controller"
            >
              {open ? 'View Less Licenses' : 'View More Licenses'}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default BusinessProfileLicenses;
